module.exports = __webpack_public_path__ + "media/uitx3.221b5382.mp4";